import React from "react";
import "../Styles/MyAgent.css";

import { FaMapMarkerAlt, FaClock } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

function MyAgent({ agentData, languages,UserData }) {
  const navigate = useNavigate();

  if (!agentData) return null;

  return (
    <div className="my-agent-main-card">
      {/* TOP */}

      <div className="my-agent-top-section">
        {/* LEFT */}

        <div className="my-agent-profile-left">
          <img
            src={
              agentData?.User?.ProfilePhotoUrl ||
              require("../assests/images/profile.png")
            }
            alt=""
            className="my-agent-profile-image"
          />

          <div>
            <h3>{agentData?.User?.FirstName}</h3>

            <div className="my-agent-stars">★★★★☆</div>

            <div className="my-agent-actions">
              <span>Remove Agent</span>

              <span
                onClick={() =>
                  navigate("/review-agent", {
                    state: {
                      agentData,
                      UserData
                    },
                  })
                }
              >
                Review Agent ❯
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT */}

        <div className="my-agent-contact-info">
          <p>Contact no : {agentData?.User?.PhoneNumber}</p>

          <p>Agent No {agentData?.AgentId}</p>
        </div>
      </div>

      <div className="hr-line"> </div>

      {/* BOTTOM */}

      <div className="my-agent-bottom-card">
        <div>
          <h4>{agentData?.BusinessName}</h4>

          <div className="my-agent-rating">★★★★☆</div>

          <div className="my-agent-meta-row">
            <div>
              <FaMapMarkerAlt /> {agentData?.User?.Address?.CityId},{" "}
              {agentData?.User?.Address?.CountryId}
            </div>

            <div>
              🌐
              {agentData?.LanguagesServe?.includes("all")
                ? " All Languages"
                : languages
                    ?.filter((item) =>
                      agentData?.LanguagesServe?.includes(item.LangId),
                    )
                    ?.slice(0, 3)
                    ?.map((item) => item.LangDesc)
                    ?.join(", ")}
            </div>

            <div>
              <FaClock /> {agentData?.BusinessExperience} years
            </div>
          </div>
        </div>

        <div
          className="my-agent-view-btn"
          onClick={() =>
            navigate("/agent-details", {
              state: {
                partner: agentData,
                languages,
                fromMyAgent: true,
              },
            })
          }
        >
          View Agency ❯
        </div>
      </div>
    </div>
  );
}

export default MyAgent;
